import {CustomerJourney} from '../customer-journey/model/customer-journey.model';
import {SurveyHeader} from '../surveys/model/survey.header.model';
import {DashboardScopeOption} from './model/dashboard-scope-option.model';

const byName = (first: DashboardScopeOption, second: DashboardScopeOption): number =>
    first.name.localeCompare(second.name);

/**
 * Cibles de restitution proposées au choix : les parcours clients, puis les enquêtes.
 *
 * Les parcours ouvrent en tête parce qu'ils englobent les enquêtes qu'on trouve juste en dessous ;
 * chaque groupe est trié par nom, seul ordre dans lequel on retrouve une cible dans une liste qui
 * peut en compter des dizaines.
 */
export const toDashboardScopeOptions = (
    customerJourneys: CustomerJourney[],
    surveys: SurveyHeader[]
): DashboardScopeOption[] => [
    ...(customerJourneys ?? [])
        .map((customerJourney): DashboardScopeOption => ({
            kind: 'CUSTOMER_JOURNEY',
            id: customerJourney.id,
            name: customerJourney.name,
        }))
        .sort(byName),
    ...(surveys ?? [])
        .map((survey): DashboardScopeOption => ({kind: 'SURVEY', id: survey.id, name: survey.name}))
        .sort(byName),
];
